import * as devisConf from '@/configuration/devisConf';

export default function miseAJourCommentaire(ligneCommande) {
  ligneCommande.type = devisConf.COMMENTAIRE;
}
